import Card from '@/components/common/Card'
import FormField from '@/components/common/FormField'
import MainHeading from '@/components/common/MainHeading'
import Layout from '@/components/layout/Layout'
import { Button } from '@/components/ui/button'
import { showToastNotification } from '@/utility/helper'
import { RoutesLink } from '@/utility/RouteLinks'
import { errorTypes } from '@/utility/validation'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

const CreateOd: React.FC = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm<any>();

    const onSubmit = async (data: any) => {
        console.log(data, "datadata");
        try {
            setIsLoading(true);
            // Simulate API call
            setTimeout(() => {
                showToastNotification("success", "OD applied successfully");
                navigate(RoutesLink.myOd || -1 as any);
                setIsLoading(false);
            }, 1000);
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    }

    return (
        <Layout>
            <div className='space-y-6'>
                <MainHeading
                    title="Apply for OD"
                    isBackButtonVisible
                    onClick={() => navigate(-1)}
                />
                <Card className='overflow-visible'>
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <FormField
                                {...register("date", { ...errorTypes.required('Date') })}
                                type="date"
                                label="Date"
                                error={errors.date?.message as string}
                            />

                            <FormField
                                {...register("location", { ...errorTypes.required('Location') })}
                                type="text"
                                label="Location"
                                placeholder="Enter location"
                                error={errors.location?.message as string}
                            />

                            <FormField
                                {...register("purpose", { ...errorTypes.required('Purpose') })}
                                type="text"
                                label="Purpose"
                                placeholder="Enter purpose for OD"
                                error={errors.purpose?.message as string}
                            />
                        </div>

                        <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-100">
                            <Button
                                type="button"
                                variant="outline"
                                onClick={() => navigate(-1)}
                                disabled={isLoading}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                disabled={isLoading}
                            >
                                {isLoading ? "Submitting..." : "Apply OD"}
                            </Button>
                        </div>
                    </form>
                </Card>
            </div>
        </Layout>
    )
}

export default CreateOd
